import { render, staticRenderFns } from "./snippet.vue?vue&type=template&id=11d44d3c&scoped=true"
import script from "./snippet.vue?vue&type=script&lang=js"
export * from "./snippet.vue?vue&type=script&lang=js"
import style0 from "./snippet.vue?vue&type=style&index=0&id=11d44d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d44d3c",
  null
  
)

/* custom blocks */
import block0 from "./snippet.vue?vue&type=custom&index=0&blockType=graphql"
if (typeof block0 === 'function') block0(component)

export default component.exports